module.exports = __webpack_public_path__ + "static/media/Motivo5.4a14db13.png";